import React from "react";
import { Tooltip } from "@mui/material";
import {
  CancelOutlined,
  CheckOutlined,
  TimerOutlined,
} from "@mui/icons-material";

const StatusLabel = ({ status, failedReason, customStyles = {} }) => {
  const normalizedStatus = status?.trim()?.toLowerCase();

  let styles = {
    icon: null,
    text: "Unknown",
    color: "#000",
    backgroundColor: "#fff",
    border: "1px solid #ccc",
  };

  let tooltipContent = status;

  if (normalizedStatus === "completed") {
    styles = {
      icon: <CheckOutlined fontSize="small" />,
      text: "Completed",
      color: "#94BA33",
      backgroundColor: "#F1F6E3",
      border: "1px solid #94BA33",
    };
  } else if (normalizedStatus === "error" || normalizedStatus === "failed") {
    styles = {
      icon: <CancelOutlined fontSize="small" />,
      text: "Failed",
      color: "#EF5350",
      backgroundColor: "#FDEDED",
      border: "1px solid #EF5350",
    };

    if (Array.isArray(failedReason)) {
      tooltipContent = (
        <ul style={{ margin: 0, paddingLeft: 16 }}>
          {failedReason.map((reason, index) => (
            <li key={index} style={{ margin: 2, fontSize: 12 }}>
              {reason}
            </li>
          ))}
        </ul>
      );
    } else if (failedReason) {
      tooltipContent = failedReason;
    }
  } else if (normalizedStatus === "pending" || normalizedStatus === "timeout") {
    styles = {
      icon: <TimerOutlined fontSize="small" />,
      text: status,
      color: "#FF9800",
      backgroundColor: "#FFF4E5",
      border: "1px solid #FF9800",
    };
  }

  const finalStyles = {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    backgroundColor: styles.backgroundColor,
    color: styles.color,
    border: styles.border,
    padding: "4px 8px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "500",
    textTransform: "capitalize",
    minWidth: "80px",
    justifyContent: "center",
    cursor: "default",
    ...customStyles,
  };

  return (
    <Tooltip title={tooltipContent}>
      <span style={finalStyles}>
        <span style={{ display: "flex", alignItems: "center" }}>
          {styles.icon}
        </span>
        <span>{styles.text}</span>
      </span>
    </Tooltip>
  );
};

export default StatusLabel;
